import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { Select, MenuItem } from '@mui/material';

import DataTable from '../../../../components/DataTable/DataTable.js';

import { SetSelectedFiles } from '../../actions/DriveTestUploadActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	},
	tableRow: {
		'&:hover': {
			cursor: 'pointer'
		}
	}
}));

const UploadSelectedFilesTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();
	const setSelectedFiles = selectedFiles => dispatch(SetSelectedFiles(selectedFiles));

	const handleFileTypeChange = (index, newFileType) => {
		// Create a new array based on the existing data
		const updatedData = [...data];

		// Update the fileType for the specific index
		updatedData[index] = {
			...updatedData[index],
			fileType: newFileType // Update fileType with the new value
		};

		// Dispatch the updated array to the Redux store
		setSelectedFiles(updatedData);
	};

	const fileTypeOptions = [
		{ value: 'Packet UL', label: 'Packet UL' },
		{ value: 'Packet DL', label: 'Packet DL' },
		{ value: 'Scanner', label: 'Scanner' },
		{ value: 'Voice MO', label: 'Voice MO' },
		{ value: 'Voice MT', label: 'Voice MT' },
		{ value: 'Unknown', label: 'Unknown' }];

	const _getTableColumns = () => (
		[
			{
				name: 'fileDirectory',
				label: 'File Directory',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'file',
				label: 'File',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'fileType',
				label: 'File Type',
				options: {
					display: true,
					filterType: 'textField',
					// Custom render function for fileType to include TextField
					customBodyRender: (value, tableMeta) => {
						const index = tableMeta.rowIndex; // Get the row index
						return (
							<Select
								value={value} // Set the value to the current value in the row
								onChange={(e) => handleFileTypeChange(index, e.target.value)} // Call a function to update state
								fullWidth // Makes the Select take full width of the cell
								size="small"
							>
								{fileTypeOptions.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						);
					}
				}
			}
		]
	);

	const options = {
		filter: false, // Disables the filter options
		search: false, // Disables the search bar
		print: false, // Disables the print button
		download: false, // Disables the download button
		viewColumns: false, // Disables the view columns option
		pagination: false, // Disables the pagination
		selectableRows: 'none', // Disables row selection checkboxes
		rowHover: false, // Disables row hover effect
		sort: false, // Disables sorting
		tableBodyHeight: '75vh', // Adjust the table body height
		responsive: 'standard', // Adjust responsive behavior
		elevation: 0, // Removes the shadow from the table
		title: true, // Hides the title
		toolbar: false, // Hides the toolbar with filter, search, etc.
		hideHeader: true, // Hides the header of the table
	};

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="kpiUploadProcessTable"
				title="Selected Files"
				data={data}
				columns={_getTableColumns()}
				// rowsPerPage={20}
				options={options}
				className={classes.tableRow}
			/>
		</div>
	);
};

UploadSelectedFilesTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default UploadSelectedFilesTable;
